module.exports = __webpack_public_path__ + "static/media/mxarchive.327a0d49.md";